import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { DemandReductionDataService, DemandReductionReach, DemandReductionStation } from '../../../../services/demand-reduction-data.service';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AccordianService } from '../../../../services/accordian.service';
import { trigger, transition, style, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-demand-reduction-table',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.5s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.5s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './demand-reduction-table.component.html',
  styleUrls: ['./demand-reduction-table.component.scss'],
  providers: [NgbAccordion]
})
export class DemandReductionTableComponent implements OnInit {

  @Input() reach: DemandReductionReach;

  @ViewChild('acc', {static: false}) acc: NgbAccordion;

  accToggle: boolean = false;

  constructor (private accordianService: AccordianService, private demandReduction: DemandReductionDataService) {}

  ngOnInit() {

    setTimeout(() => {

      this.accordianService.currentAccordian.subscribe(accordian => {
        if (accordian[this.reach.stations[0].reachNumber]) {
          this.accToggle = true;
        } else {
          this.accToggle = false;
        }
      });
  
      this.demandReduction.currentDemandReduction.subscribe(demandReduction => {
          if (this.accToggle) {
            this.acc.expand('ngb-panel-' + this.reach.stations[0].reachNumber);
          } else {
            this.acc.collapse('ngb-panel-' + this.reach.stations[0].reachNumber);
          }          
      });
        
    });

  }

  accToggleMethod() {
    this.accordianService.changeAccordian(this.reach.stations[0].reachNumber);
  }

}